export default __webpack_public_path__ + "0489086086e3815cf9cb4b6f42cded01.svg";